import {
    CREATEEXERCISECHARTTYPE,
    GETEXERCISECHARTTYPE,
    UPDATEEXERCISECHARTTYPE,
    DELETEEXERCISECHARTTYPE,
    CREATEEXERCISECHARTHEAD,
    GETEXERCISECHARTHEAD,
    UPDATEEXERCISECHARTHEAD,
    DELETEEXERCISECHARTHEAD,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEEXERCISECHARTTYPE:
            return {
                ...state,
                exerciseCharttypeSaveStatus: action.payload.success,
            }
        case GETEXERCISECHARTTYPE:
                return {
                        ...state,
                        exerciseCharttypeList: action.payload.data,
                        }
        case UPDATEEXERCISECHARTTYPE:
                return {
                        ...state,
                        exerciseCharttypeUpdateStatus: action.payload.success,
                        }   

        case DELETEEXERCISECHARTTYPE:
                 return {
                     ...state,
                     exerciseCharttypeDeleteStatus: action.payload.success,
                        } 
        case CREATEEXERCISECHARTHEAD:
                return {
                        ...state,
                        exerciseChartheadSaveStatus: action.payload.success,
                        }
        case GETEXERCISECHARTHEAD:
                 return {
                        ...state,
                        exerciseChartheadList: action.payload.data,
                        }
        case UPDATEEXERCISECHARTHEAD:
                return {
                        ...state,
                        exerciseChartheadUpdateStatus: action.payload.success,
                        }   
                
        case DELETEEXERCISECHARTHEAD:
                    return {
                            ...state,
                            exerciseChartheadDeleteStatus: action.payload.success,
                            } 
        default:
                return state
                      }
                 }